import { Box, Divider, Grid, Stack, Skeleton } from '@mui/material';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';

const FONT_SIZE = 18;

export default function CurrentPlanDetailsSkeleton() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      {/* Header */}
      <Box mt={3}>
        <Box className={globalStyles.sectionContainer}>
          <Box
            className={globalStyles.sectionHeader}
            sx={{ position: 'relative' }}
          >
            <Box>
              {/* Plan Name */}
              <Skeleton
                variant="text"
                width={120}
                height={28}
                sx={{ bgcolor: colors.skeleton }}
              />
              {/* Price */}
              <Skeleton
                variant="text"
                width={160}
                height={24}
                sx={{ bgcolor: colors.skeleton }}
              />
            </Box>

            {/* Plan Icon */}
            <Skeleton
              width={25}
              height={50}
              sx={{
                position: 'absolute',
                right: 30,
                top: -12,
                bgcolor: colors.skeleton,
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Grid
        container
        spacing={{
          xs: 0,
          lg: 1.5
        }}>
        {/* Left section */}
        <Grid
          mt={3}
          className={globalStyles.sectionContainer}
          size={{ xs: 12, lg: 6 }}
        >
          <Box className={globalStyles.sectionHeader}>
            <Skeleton
              variant="text"
              width={150}
              height={26}
              sx={{ bgcolor: colors.skeleton }}
            />
          </Box>

          <Divider />

          <Stack px={2} pt={1} pb={1.5} spacing={1}>
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
            <Divider />
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
            <Divider />
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
            <Divider />
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
          </Stack>
        </Grid>

        {/* Right section */}
        <Grid
          mt={3}
          className={globalStyles.sectionContainer}
          size={{ xs: 12, lg: 6 }}
        >
          <Box className={globalStyles.sectionHeader}>
            <Skeleton
              variant="text"
              width={150}
              height={26}
              sx={{ bgcolor: colors.skeleton }}
            />
          </Box>

          <Divider />

          <Stack px={2} pt={1} pb={1.5} spacing={1}>
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
            <Divider />
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
            <Divider />
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
            <Divider />
            <Skeleton
              variant="text"
              height={FONT_SIZE + 8}
              sx={{ bgcolor: colors.skeleton }}
            />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}